import React, { Component } from 'react';
import { connect } from 'react-redux';

import Toolbar from 'base/components/common/Toolbar';
import Modal from 'base/components/Modal';
import API, { AUTH_HEADER, GET_AUTH} from 'base/api';

// import List from '../components/List';
import StudentsTable from '../components/StudentsTable';
import EditStudentForm from '../components/EditStudentForm';
import MakeMail from '../components/MakeMail';
import { fetchAllStudents } from 'modules/Admin/redux/actions/getStudentsAction';
import { deleteStudent } from 'modules/Admin/redux/actions/deleteStudent';


import { omit } from 'lodash';
// const keysToSearch = [
//   'firstName', 'surname', 'mail', 'index'
// ];

const AdvanceSearch = (props) => {
  const { onChange } = props;
  return(
    <div className="advance-search">
      <input type="search" className="cc-search-input" placeholder="Po nazwisku"
        data-search="surname"
        onChange={onChange}
      />
      <input type="search" className="cc-search-input" placeholder="Po indeksie"
        data-search="index"
        onChange={onChange}
      />
      <input type="search" className="cc-search-input" placeholder="Po mailu"
        data-search="mail"
        onChange={onChange}
      />
      <input type="search" className="cc-search-input" placeholder="Po statusie"
        data-search="statusStudent"
        onChange={onChange}
      />
      <input type="search" className="cc-search-input" placeholder="Po płatności"
        data-search="paymentsInfo"
        onChange={onChange}
      />
    </div>
  )
}


const Stats = (props) => {
  const { data } = props;
  const numberOfAll = data.length;
  const depArr = data.map( item => item.department);
  const info = depArr.reduce((b,c)=>((b[b.findIndex(d=>d.el===c)]||b[b.push({el:c,count:0})-1]).count++,b),[]);

  return(
    <div className="stats-wrapper">
      <p>Zapisanych: <strong>{numberOfAll}</strong></p>
      {info.map( item =>
        <p>{item.el} : <strong>{item.count}</strong></p>
      )}
    </div>
  )
}

const Filter = (props) => {
  const { data } = props;
  const numberOfAll = data.length;
  const depArr = data.map( item => item.department);
  const info = depArr.reduce((b,c)=>((b[b.findIndex(d=>d.el===c)]||b[b.push({el:c,count:0})-1]).count++,b),[]);

  return(
    <div className="stats-wrapper">
      <p>Zapisanych: <strong>{numberOfAll}</strong></p>
      {info.map( item =>
        <p>{item.el} : <strong>{item.count}</strong></p>
      )}
    </div>
  )
}

class StudentListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: false,
      error: null,
      sortBy: null,
      editedStudent: null,
      isMailToSend: false,
      sendingMail: false
    }
  }

  fetchStudents = () => {
    this.setState({isLoading: true});
    fetch(API.GET_ALL_STUDENTS, GET_AUTH)
    .then( res => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Something went wrong ...');
      }
    })
    .then(data => this.setState({ data: data ? data : [], filteredData: data ? data : [], isLoading: false }))
    .catch(error => this.setState({ error: error.message, isLoading: false }));
  }

  handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    const searchType = e.target.dataset.search;
    const { data } = this.state;
    // console.log(this.advanceSearch)
    const newFilteredData = data.filter(e => e[searchType] ? e[searchType].toString().toLowerCase().search(value) !== -1 : false);

    this.setState({filteredData: newFilteredData});
  }

  sortData = (data, sortBy) => {
    // console.log(sortBy)
    return sortBy ? data.sort((a, b) => a[sortBy].toString().toLowerCase() - b[sortBy].toString().toLowerCase()) : data;
  }

  deleteStudent = (id) => {
    const { dispatch } = this.props;
    if(window.confirm("AR JU SZUR? Chesz usunąć tego studenciaka ?? ")) {
      dispatch(deleteStudent(id))
    }
  }

  deleteGroupStudent = (ids) => {
    if ( prompt("ARE JU SZUR???! usunąć " + ids.length + " studenciaków?") ) {
      console.log("a")
    }
    console.log("b");
    // const { dispatch } = this.props;
    // dispatch(deleteStudent(id))
  }

  handleEdit = (id) => {
    console.log(id);
    const { students } = this.props;
    console.log(students)
    const student = students.data.find( e => e._id === id);
    console.log(student)

    const nee = omit(student, "_id");
    console.log(nee);
    this.setState({editedStudent: student});
  }

  handleUpdateStudent = (updatedData) => {
    // const id = updatedData._id;
    // let newData = {...updatedData};
    // delete newData._id;

    const nee = omit(updatedData, "_id");
    console.log(nee);
    // fetch(API.UPDATE_STUDENT + id, {
    //   method: 'POST',
    //   body: JSON.stringify(newData),
    //   headers: new Headers(AUTH_HEADER)
    // })
    // .then( res => {
    //   if (res.ok) {
    //     return res.json();
    //   } else {
    //     throw new Error('Something went wrong ...');
    //   }
    // })
    // .then( res => {
    //   switch(res.code) {
    //     case '010':
    //       this.fetchStudents();
    //       break;
    //     default:
    //       throw new Error('Coś nie tak z updetowaniem');
    //   }
    //   // console.log(res)
    // })
    // .catch(error => this.setState({ error: error.message, isLoading: false }));
    // this.setState({editedStudent: null})
  }

  handleEditClose = () => {
    this.setState({editedStudent: null, isMailToSend: false});
  }

  handleOpenMailEditor = (data) => {
    this.setState({
      isMailToSend: true,
      mailRecipients: data
    });
  }

  handleSendMail = (html, subject, type) => {
    const { mailRecipients } = this.state;
    this.setState({sendingMail: true});
    if ( mailRecipients.length ){
      const data = {
        students: mailRecipients,
        subject: subject,
        content: html,
        type: type
      }
      // console.log(data);
      fetch(API.SEND_MAILS, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: new Headers(AUTH_HEADER)
      })
      .then( res => {
        // console.log(res);
        if (res.ok) {
          return res.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      })
      .then( res => {
        if (res.code == '011') {
          this.setState({isMailToSend: false, sendingMail: false});
          alert("Wysyłanie rozpoczęte!");
        } else {
          throw new Error('Coś poszło nie tak!!@#!@#');
        }
      })
      .catch(error => {alert("Error" + error); this.setState({isMailToSend: false, sendingMail: false});});
    }
  }

  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(fetchAllStudents());
  }

  render() {
    const { filteredData, isLoading, sortBy, editedStudent, isMailToSend, sendingMail } = this.state;
    const { data } = this.props.students;
    return (
      <div>
        <Toolbar title="< Panel admina | Studenci" titleUrl="/admin" />
        <div className="container">
          {/* <input type="search" className="cc-search-input" placeholder="Szukajka"
            onChange={this.handleSearchChange}
          /> */}
          {/* {
            isLoading ? <p>Loading that shit...</p> : <Stats data={data} />
          } */}
          {/* <AdvanceSearch onChange={this.handleSearchChange} /> */}
          {
            isLoading
              ? <p>Loading that shit...</p>
              : <StudentsTable title="Lista studentów"
                  data={this.sortData(filteredData || data, sortBy)}
                  onDelete={this.deleteStudent}
                  onEdit={this.handleEdit}
                  onSort={s => this.setState({sortBy: s})}
                  onMailCreating={this.handleOpenMailEditor} />
          }
        </div>
        {/* {
          isMailToSend &&
          <Modal onClose={this.handleEditClose}>
            <MakeMail onSubmit={this.handleSendMail} data={this.state.mailRecipients} isSending={sendingMail} />
          </Modal>
        }
        {
          editedStudent &&
          <Modal onClose={this.handleEditClose}>
            <EditStudentForm initialValues={editedStudent} onSubmit={this.handleUpdateStudent}/>
          </Modal>
        } */}
      </div>
    );
  }
};

export default connect(
  state => ({
    students: state.students})
)(StudentListView);



// WEBPACK FOOTER //
// ./src/modules/Admin/views/StudentListView.js